import apiClient from './client'
import type {
  NotificationPreference,
  NotificationPreferenceUpdate,
  AlertHistory,
  Webhook,
  WebhookCreate,
  WebhookUpdate,
  WebhookListResponse,
} from '../types'

export interface AlertHistoryResponse {
  alerts: AlertHistory[]
  total: number
}

export const alertsApi = {
  getPreferences: async (): Promise<NotificationPreference> => {
    const response = await apiClient.get<NotificationPreference>('/alerts/preferences')
    return response.data
  },

  updatePreferences: async (
    data: NotificationPreferenceUpdate
  ): Promise<NotificationPreference> => {
    const response = await apiClient.put<NotificationPreference>('/alerts/preferences', data)
    return response.data
  },

  getHistory: async (params?: {
    app_id?: string
    alert_type?: string
    skip?: number
    limit?: number
  }): Promise<AlertHistoryResponse> => {
    const response = await apiClient.get<AlertHistoryResponse>('/alerts/history', {
      params,
    })
    return response.data
  },

  // Webhook endpoints
  listWebhooks: async (): Promise<Webhook[]> => {
    const response = await apiClient.get<WebhookListResponse>('/alerts/webhooks')
    return response.data.webhooks
  },

  createWebhook: async (data: WebhookCreate): Promise<Webhook> => {
    const response = await apiClient.post<Webhook>('/alerts/webhooks', data)
    return response.data
  },

  getWebhook: async (webhookId: string): Promise<Webhook> => {
    const response = await apiClient.get<Webhook>(`/alerts/webhooks/${webhookId}`)
    return response.data
  },

  updateWebhook: async (webhookId: string, data: WebhookUpdate): Promise<Webhook> => {
    const response = await apiClient.put<Webhook>(`/alerts/webhooks/${webhookId}`, data)
    return response.data
  },

  deleteWebhook: async (webhookId: string): Promise<void> => {
    await apiClient.delete(`/alerts/webhooks/${webhookId}`)
  },
}

export type {
  NotificationPreference,
  NotificationPreferenceUpdate,
  AlertHistory,
  Webhook,
  WebhookCreate,
  WebhookUpdate,
}
